import moment from 'moment';

export default {
  data: () => ({
    focusDate: moment(),
  }),
  computed: {
    calendar() {
      const now = moment();
      const date = moment(this.focusDate).startOf('month');

      const calendar = {
        weeks: [],
        meta: {
          now,
          focusedDate: this.focusDate,
          firstCalendarDate: date.clone().startOf('isoWeek'),
          lastCalendarDate: date.clone().add(5, 'week').endOf('isoWeek'),
          month: this.focusDate.month(),
          week: this.focusDate.isoWeek(),
        },
        header: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      };

      for (let i = 0; i < 6; i += 1) {
        const week = date.clone().startOf('isoWeek').add(i, 'week');

        const days = Array(7)
          .fill(0)
          .map((n, j) => {
            const d = week
              .clone()
              .startOf('isoWeek')
              .add(n + j, 'day');

            return {
              day: d,
              meta: {
                isFirstDayOfWeek: j === 0,
                isDiffMonth: d.get('month') !== date.get('month'),
                isToday: d.format('YYYY-MM-DD') === now.format('YYYY-MM-DD'),
                isFocusedDay: d.format('YYYY-MM-DD') === this.focusDate.format('YYYY-MM-DD'),
              },
            };
          });

        calendar.weeks.push({
          number: week.isoWeek(),
          days,
        });
      }

      return calendar;
    },
  },
  watch: {
    'calendar.meta.month': function calendarMetaMonthWatcher() {
      this.$emit('changed', this.calendar);
    },
  },
  created() {
    this.$emit('created', this.calendar);
  },
  methods: {
    nextMonth() {
      this.focusDate = this.focusDate.clone().add(1, 'month');
    },
    prevMonth() {
      this.focusDate = this.focusDate.clone().subtract(1, 'month');
    },
    nextWeek() {
      this.focusDate = this.focusDate.clone().add(1, 'week');
    },
    prevWeek() {
      this.focusDate = this.focusDate.clone().subtract(1, 'week');
    },
    setDate(date) {
      this.focusDate = moment(date);
    },
    setMonth(month) {
      this.focusDate = this.focusDate.clone().month(month);
    },
  },
  render() {
    return this.$scopedSlots.default({
      data: {
        calendar: this.calendar,
      },
      actions: {
        prevMonth: this.prevMonth,
        nextMonth: this.nextMonth,
        prevWeek: this.prevWeek,
        nextWeek: this.nextWeek,
        setDate: this.setDate,
        setMonth: this.setMonth,
      },
    });
  },
};
